<template>
  <main class="home">
    <h1>Přehled</h1>
  </main>
</template>